import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { SafeUrl } from '@angular/platform-browser';
import { BibliographyService } from '../../../services/bibliography.service';
import { VocsService } from '../../../services/vocs.service';
import { PaginationInstance } from 'ngx-pagination';
import { BibListFilters } from '../../../models/bib-list-filters';
import { BiblioRecord, BiblioRecordList } from '../../../models/biblio-record';
import { VocTerms } from '../../../models/voc-term';

@Component({
  selector: 'app-biblio-list',
  templateUrl: './biblio-list.component.html',
  styleUrls: ['./biblio-list.component.css']
})
export class BiblioListComponent implements OnInit {
    private bibListFilters: BibListFilters;
    biblioList: BiblioRecordList;
    biblioRespTypesVoc: VocTerms; // vocabulary of biliographic responsability types
    config: PaginationInstance = {
        id: 'biblio-list-navigation',
        itemsPerPage: 10,
        currentPage: 1
    };

    constructor(
        private route: ActivatedRoute,
        private bibliographyService: BibliographyService,
        private vocsService: VocsService
    ) {
    }

    ngOnInit(): void {
        /* Clone the parameters to be able to manipulate them */
        const routeParams = Object.assign({}, this.route.snapshot.params);

        this.bibliographyService.getBiblioRecords().subscribe(
            response => {
                this.biblioList = response;
                this.bibliographyService.getBibListFilters().subscribe(
                    bibListFilters => {
                        this.bibListFilters = bibListFilters;
                        if (routeParams['bibId']) {
                            const bibId = parseInt(routeParams['bibId'], 10);
                            const biblioRecord = this.biblioList.find(
                                function (bibRecord: BiblioRecord) {
                                    return bibRecord.pkid === bibId;
                                }
                            );
                            if (biblioRecord) {
                                this.bibListFilters.quotation_label = biblioRecord.quotation_label;
                                this.biblioList = this.biblioList.filter(
                                    function (bibRecord: BiblioRecord) {
                                        return bibRecord.pkid === bibId;
                                    }
                                );
                                /* Avoids processing the input parameter several times (and no reloading the page) */
                                routeParams['bibId'] = undefined;
                            }
                        }
                    },
                    err => console.error(err)
                );
            },
            err => console.error(err)
        );
        this.vocsService.getBiblioRespTypes().subscribe(
            response => this.biblioRespTypesVoc = response,
            err => console.error(err)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/biblio-list/biblio-list.component.ts